import Connections from '@/components/Settings/Connections';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import React from 'react';

const Destinations = () => {

  return (
    <div>
      <Card className="hidden">
        <CardHeader>
          <CardTitle>Security Settings</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span>Two-factor authentication</span>
              <Switch />
            </div>
            <div className="flex items-center justify-between">
              <span>Password reset every 90 days</span>
              <Switch />
            </div>
            <Button disabled>Change Password</Button>
          </div>
        </CardContent>
      </Card>
      <Connections />
    </div>
  );
};

export default Destinations;
